import { createRtpStreamHandler } from '../../../MediaController';
import { MediaControllerController } from './MediaControllerController';

export class RtspController extends MediaControllerController {
    readonly type = 'RTSP';

    constructor(wrapperElement: HTMLDivElement, url: string) {
        const handler = createRtpStreamHandler({
            continuousPlayback: true,
            muted: false,
            videoUrl: url,
        });
        super(wrapperElement, handler);
    }
}
